// Beds4u Interactivity & Animations

// =========================
// HEADER & NAVIGATION SCRIPTS (Shopify Optimized)
// =========================

document.addEventListener('DOMContentLoaded', function() {
      new Swiper('.slider-swiper', {
        loop: true,
        pagination: {
          el: '.slider-swiper .swiper-pagination',
          clickable: true
        },
        navigation: false,
        slidesPerView: 1,
        effect: 'slide',
        speed: 600
      });

      // Initialize testimonials carousel
      const testimonialsSwiper = new Swiper('.testimonials-carousel__swiper', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
          nextEl: '.testimonials-carousel__btn--next',
          prevEl: '.testimonials-carousel__btn--prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 30,
          }
        },
        speed: 600
      });
    });

document.addEventListener('DOMContentLoaded', function() {
  // --- MOBILE MENU TOGGLE ---
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (mobileMenuToggle && mobileMenu) {
    // Accessibility
    mobileMenuToggle.setAttribute('aria-label', 'Toggle menu');
    mobileMenuToggle.setAttribute('aria-expanded', 'false');

    mobileMenuToggle.addEventListener('click', function() {
      const isActive = this.classList.toggle('active');
      mobileMenu.classList.toggle('active');
      document.body.classList.toggle('menu-open');
      document.body.classList.toggle('no-scroll');
      this.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    // Close menu when clicking on menu links (but not dropdown toggles)
    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', function(e) {
        // If this is a dropdown toggle, don't close
        if (this.closest('.mobile-category-item__dropdown-btn')) return;
        mobileMenuToggle.classList.remove('active');
        mobileMenu.classList.remove('active');
        document.body.classList.remove('no-scroll');
        document.body.classList.remove('menu-open');
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
      });
    });

    // Close menu when clicking outside
    document.addEventListener('click', function(e) {
      if (!mobileMenuToggle.contains(e.target) && !mobileMenu.contains(e.target)) {
        mobileMenuToggle.classList.remove('active');
        mobileMenu.classList.remove('active');
        document.body.classList.remove('no-scroll');
        document.body.classList.remove('menu-open');
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
      }
    });

    // Close menu on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('active')) {
        mobileMenuToggle.classList.remove('active');
        mobileMenu.classList.remove('active');
        document.body.classList.remove('no-scroll');
        document.body.classList.remove('menu-open');
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // --- MOBILE CATEGORY DROPDOWN TOGGLE ---
  document.querySelectorAll('.mobile-category-item--has-subitems .mobile-category-item__dropdown-btn').forEach(function(btn) {
    btn.setAttribute('aria-label', 'Toggle subcategories');
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const parentLi = this.closest('.mobile-category-item--has-subitems');
      const isActive = parentLi.classList.toggle('active');
      this.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
  });

  // --- STICKY CATEGORIES MENU ON SCROLL (Desktop) ---
  const headerBottom = document.querySelector('.header__bottom');
  const headerBottomPlaceholder = document.querySelector('.header__bottom-placeholder');
  let lastScrollY = window.scrollY;
  let isScrollingUp = false;
  let stickyTicking = false;

  function handleStickyMenu() {
    const currentScrollY = window.scrollY;
    isScrollingUp = currentScrollY < lastScrollY;
    if (currentScrollY > 60) {
      if (isScrollingUp) {
        headerBottom && headerBottom.classList.add('is-sticky', 'is-visible');
        headerBottomPlaceholder && (headerBottomPlaceholder.style.display = 'block');
      } else {
        headerBottom && headerBottom.classList.add('is-sticky');
        headerBottom && headerBottom.classList.remove('is-visible');
        headerBottomPlaceholder && (headerBottomPlaceholder.style.display = 'block');
      }
    } else {
      headerBottom && headerBottom.classList.remove('is-sticky', 'is-visible');
      headerBottomPlaceholder && (headerBottomPlaceholder.style.display = 'none');
    }
    lastScrollY = currentScrollY;
    stickyTicking = false;
  }

  function onScroll() {
    if (!stickyTicking) {
      window.requestAnimationFrame(handleStickyMenu);
      stickyTicking = true;
    }
  }
  window.addEventListener('scroll', onScroll);
  handleStickyMenu();

  // --- ACCESSIBILITY: Close mobile menu on Shopify section reloads (optional) ---
  document.addEventListener('shopify:section:load', function() {
    if (mobileMenuToggle && mobileMenu) {
      mobileMenuToggle.classList.remove('active');
      mobileMenu.classList.remove('active');
      document.body.classList.remove('menu-open');
      mobileMenuToggle.setAttribute('aria-expanded', 'false');
    }
  });

  // --- END HEADER SCRIPTS ---

  // === Categories Carousel Swiper ===
  if (window.Swiper) {
    new Swiper('.categories-carousel__swiper-categories', {
      slidesPerView: 4.5,
      spaceBetween: 20,
      freeMode: true,
      navigation: {
        nextEl: '.categories-carousel__btn--next-categories',
        prevEl: '.categories-carousel__btn--prev-categories',
      },
      breakpoints: {
        1025: { slidesPerView: 4.5, spaceBetween: 20 },
        769: { slidesPerView: 3.5, spaceBetween: 16 },
        601: { slidesPerView: 2.5, spaceBetween: 12 },
        0: { slidesPerView: 1.5, spaceBetween: 8 }
      },
      loop: true,
      watchOverflow: true,
    });
    new Swiper('.categories-carousel__swiper-bestsellers', {
      slidesPerView: 4.5,
      spaceBetween: 20,
      freeMode: true,
      navigation: {
        nextEl: '.categories-carousel__btn--next-bestsellers',
        prevEl: '.categories-carousel__btn--prev-bestsellers',
      },
      breakpoints: {
        1025: { slidesPerView: 4.5, spaceBetween: 20 },
        769: { slidesPerView: 3.5, spaceBetween: 16 },
        601: { slidesPerView: 2.5, spaceBetween: 12 },
        0: { slidesPerView: 1.5, spaceBetween: 8 }
      },
      loop: true,
      watchOverflow: true,
    });
    new Swiper('.categories-carousel__swiper-onsale', {
      slidesPerView: 4.5,
      spaceBetween: 20,
      freeMode: true,
      navigation: {
        nextEl: '.categories-carousel__btn--next-onsale',
        prevEl: '.categories-carousel__btn--prev-onsale',
      },
      breakpoints: {
        1025: { slidesPerView: 4.5, spaceBetween: 20 },
        769: { slidesPerView: 3.5, spaceBetween: 16 },
        601: { slidesPerView: 2.5, spaceBetween: 12 },
        0: { slidesPerView: 1.5, spaceBetween: 8 }
      },
      loop: true,
      watchOverflow: true,
    });
  }

  // FAQ Accordion Interactivity
  document.querySelectorAll('.faq-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      // Collapse all in the same accordion
      document.querySelectorAll('.faq-toggle').forEach(function(otherBtn) {
        if (otherBtn !== btn) {
          otherBtn.setAttribute('aria-expanded', 'false');
          otherBtn.querySelector('.faq-toggle-icon').textContent = '+';
          // Hide answer and remove inline style if present
          const answer = otherBtn.parentElement.querySelector('.faq-answer');
          if (answer) answer.style.display = '';
        }
      });
      // Toggle this one
      btn.setAttribute('aria-expanded', !expanded);
      btn.querySelector('.faq-toggle-icon').textContent = expanded ? '+' : '−';
      // Show/hide answer and remove inline style if present
      const answer = btn.parentElement.querySelector('.faq-answer');
      if (!expanded) {
        answer.style.display = 'block';
      } else {
        answer.style.display = '';
      }
    });
  });

  // New Accordion Functionality
  document.querySelectorAll('.accordion-header').forEach(function(header) {
    header.addEventListener('click', function() {
      const accordionItem = this.closest('.accordion-item');
      const accordionContent = accordionItem.querySelector('.accordion-content');
      const toggleIcon = this.querySelector('.accordion-toggle');
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      // Close all other accordion items in the same accordion
      const accordion = this.closest('.accordion');
      accordion.querySelectorAll('.accordion-item').forEach(function(item) {
        if (item !== accordionItem) {
          const otherHeader = item.querySelector('.accordion-header');
          const otherContent = item.querySelector('.accordion-content');
          const otherToggleIcon = otherHeader.querySelector('.accordion-toggle');
          
          otherHeader.setAttribute('aria-expanded', 'false');
          item.classList.remove('active');
          otherContent.style.maxHeight = '0';
          otherToggleIcon.classList.remove('fa-minus');
          otherToggleIcon.classList.add('fa-plus');
        }
      });
      
      // Toggle current accordion item
      if (isExpanded) {
        this.setAttribute('aria-expanded', 'false');
        accordionItem.classList.remove('active');
        accordionContent.style.maxHeight = '0';
        toggleIcon.classList.remove('fa-minus');
        toggleIcon.classList.add('fa-plus');
      } else {
        this.setAttribute('aria-expanded', 'true');
        accordionItem.classList.add('active');
        accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
        toggleIcon.classList.remove('fa-plus');
        toggleIcon.classList.add('fa-minus');
      }
    });
  });

  // Make span.newsletter-input-text act as a submit trigger for the newsletter form

  document.querySelectorAll('.newsletter-form').forEach(function(form) {
    var trigger = form.querySelector('span.newsletter-input-text');
    if (trigger) {
      trigger.style.cursor = 'pointer';
      trigger.addEventListener('click', function() {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  });
}); 